import pythonApiClient from './pythonBaseApi';

/**
 * Consulta: comensales con el mismo servicio/fecha en 2+ comedores (por proyecto).
 */
const consultaServiciosDuplicadosApi = {
  listarCasos: (params = {}) => {
    return pythonApiClient.get(
      '/consultas/alimentacion/servicios-duplicados/casos',
      { params }
    );
  },

  eliminarAtencion: (idTurnoDetalle) => {
    return pythonApiClient.delete(
      `/consultas/alimentacion/servicios-duplicados/atencion/${idTurnoDetalle}`
    );
  },
};

export default consultaServiciosDuplicadosApi;
